/**
 * orga-app-api - incidents-v1-oa3_1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface Veranstaltung { 
    titel: string;
    beginn_utc?: Date;
    einlass_utc?: Date;
    ist_beendet?: boolean;
    ist_veroeffentlicht?: boolean;
    ist_freigegeben?: boolean;
    saison?: string;
    saison_id?: string;
    ist_geloescht?: boolean;
    ist_reaktiviert?: boolean;
    typ_bezeichnung?: string;
    typ_id: string;
    veranstaltung_id: string;
    mandant_id?: string;
    modified_on_utc?: Date;
}

